var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlSnackbarMv',{attrs:{"active":_vm.active,"message":_vm.message,"is-error":_vm.isError},on:{"update:active":function($event){_vm.active=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }